import ACTIONS from "../actions/action";
import _ from "lodash";

const View = {
  CONFIGURE: "CONFIGURE",
  BILL_OF_MATERIALS: "BILL_OF_MATERIALS"
};

const defaultState = {
  configuration: {},
  ui: {
    saved:false,
    next:false
  },
  billOfMaterials:[],
  currentView:View.CONFIGURE,
  pii:{},
  localeSettings:{}
};

const todoReducer = (state = defaultState, action) => {
  switch (action.type) {

    case ACTIONS.Types.SET_CONFIG_ITEM: {
      let item = action.payload;
      let newState = _.cloneDeep(state);
      if(item.id){
        newState.configuration[item.id] = item.value;
        newState.ui.next = true;
      }
      return newState;
    }

    case ACTIONS.Types.SET_QUOTE_ITEM: {
      let item = action.payload;
      let newState = _.cloneDeep(state);
      if(item.id){
        newState.pii[item.id] = item.value;
      }
      return newState;
    }

    case ACTIONS.Types.DELETE_ITEM: {
      let newState = _.cloneDeep(state);
      let index = _.findIndex(newState.billOfMaterials, action.payload);
      if(index && index!==-1)
        newState.items.splice(index, 1);
      return newState;
    }

    case ACTIONS.Types.SAVE_CONFIG: {
      let newState = _.cloneDeep(state);

      newState.configuration.saved = true;
      newState.billOfMaterials.push(newState.configuration);
      newState.currentView = View.BILL_OF_MATERIALS;

      delete newState.configuration;
      newState.configuration = {saved:false};

      return newState;
    }

    case ACTIONS.Types.RESET_CONFIG: {
      let newState = _.cloneDeep(state);
      newState.currentView = View.CONFIGURE;

      return newState;
    }

    case ACTIONS.Types.VIEW_BOM: {
      let newState = _.cloneDeep(state);
      newState.currentView = View.BILL_OF_MATERIALS;

      return newState;
    }

    case ACTIONS.Types.EDIT_BOM: {
      let item = action.payload;
      let newState = _.cloneDeep(state);
      if(item.hasOwnProperty("index") && item.index!==-1){
        newState.billOfMaterials[item.index] = item.data;
      }
      return newState;
    }

    case ACTIONS.Types.DELETE_CONFIG: {
      let item = action.payload;
      let newState = _.cloneDeep(state);
      // if(item.index && item.index!==-1){
      newState.billOfMaterials.splice(item.index, 1);
      // }
      return newState;
    }

    case ACTIONS.Types.CLEAR_PII: {
      let newState = _.cloneDeep(state);
      newState.pii = {};

      return newState;
    }

    case ACTIONS.Types.LOCALE_SETTINGS: {
      let newState = _.cloneDeep(state);
      console.log("window.location.host:", window.location.host);

      //Local testing
      // if(window.location.host == "localhost:3001"){

      if(window.location.host == "creelighting-canada.com"){
        newState.localeSettings = {
          state: "Province"
        };
      }else{
        newState.localeSettings = {
          state: "State"
        };
      }

      return newState;
    }

    default:
      return state;
  }
};

export default todoReducer;
